import { MdDatepickerIntl } from '@angular/material';

export class HCIDateIntl extends MdDatepickerIntl {
    calendarLabel: string = 'Calendario';
    openCalendarLabel: string = 'Abrir';
    prevMonthLabel: string = 'Mes anterior';
    nextMonthLabel: string = 'Mes siguiente';
    prevYearLabel: string  = 'Año anterior';
    nextYearLabel: string = 'Año siguiente';
    switchToMonthViewLabel: string = 'Cambiar a vista mensual';
    switchToYearViewLabel: string = 'Cambiar a vista anual';
    monthYearLabel: string = 'Mes';
}



// WEBPACK FOOTER //
// ./src/app/dateFormat/hcidateintl.ts